import { sum } from 'lib/array/arrayUtils'

export function getMyGroupPaymentContribution(
  details: App.GroupPaymentDetails | undefined,
  customerId: string | undefined,
): App.GroupPaymentContributionDetails | undefined {
  if (!details || !customerId) {
    return undefined
  }

  return details.contributions.find(contribution => contribution.customerId === customerId)
}

export function getGroupPaymentTotalAmount(details: App.GroupPaymentDetails): number {
  return sum(
    details.contributions.filter(contribution => contribution.status !== 'cancelled'),
    contribution => contribution.amount,
  )
}
